import React from "react";
import PropTypes from "prop-types";
import EventForm from "../../../forms/EventForm";
import { selectVenues } from "../../../../redux/venues/selectors";
import { selectEvents } from "../../../../redux/events/selectors";
import { connect } from "react-redux";
import { EVENT_ACTIONS } from "../../../../redux/events/actions";
import { VENUES_ACTIONS } from "../../../../redux/venues/actions";
import { ajaxErrorHandler, defaultSuccess } from "../../../../libs/utils";
import { generateAndSendAllVouchers, generateAllVouchers } from "../../../../services/api/events";

class _EventDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this._handleUpdate = this._handleUpdate.bind(this);
    this._generateAndSendAllVouchers = this._generateAndSendAllVouchers.bind(this);
    this._generateAllVouchers = this._generateAllVouchers.bind(this);
  }

  static propTypes = {
    events: PropTypes.array,
    venues: PropTypes.array,
    event: PropTypes.object,
    updateEvent: PropTypes.func,
    loadVenues: PropTypes.func
  };

  UNSAFE_componentWillMount() {
    this.props.loadVenues();
  }

  _mapFormToAPI(formValues) {
    const data = {
      name: formValues.name,
      dayStartTime: formValues.day_start_hour.utcOffset(0).format("hh:mm"),
      venueId: formValues.venue,
      reportingActive: formValues.reporting_active,
      crewMemberWelcomeHtml: formValues.crew_member_welcome_html,
      crewAdminWelcomeHtml: formValues.crew_admin_welcome_html,
      registrationStartsAt: formValues.registration_start.format(
        "YYYY-MM-DD hh:mm:ss"
      ),
      registrationEndsAt: formValues.registration_end.format(
        "YYYY-MM-DD hh:mm:ss"
      ),
      registrationReminderStartsAt: formValues.reminder_start.format(
        "YYYY-MM-DD hh:mm:ss"
      ),
      registrationReminderEndsAt: formValues.reminder_end.format(
        "YYYY-MM-DD hh:mm:ss"
      ),
      bornBefore: formValues.bornBefore.format("YYYY-MM-DD")
    };

    if (formValues.previous_event && formValues.previous_event !== "") {
      data.previousEventId = formValues.previous_event;
    }

    return data;
  }

  _handleUpdate(values) {
    const data = this._mapFormToAPI(values);
    this.props.updateEvent(values.id, data);
  }

  _generateAndSendAllVouchers() {
    generateAndSendAllVouchers(this.props.event.id)
        .then(response => {
          defaultSuccess("All vouchers generating and sending...");
        })
        .catch(ajaxErrorHandler);
  }

  _generateAllVouchers() {
    generateAllVouchers(this.props.event.id)
        .then(response => {
          defaultSuccess("All vouchers generating...");
        })
        .catch(ajaxErrorHandler);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {}

  render() {
    const { events, venues, event } = this.props;
    return (
      <div className="row">
        <div className="col-xl-6">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <span className="m-portlet__head-icon">
                    <i className="flaticon-edit" />
                  </span>
                  <h3 className="m-portlet__head-text">General Info</h3>
                </div>
              </div>
            </div>
            <EventForm
              onSubmit={this._handleUpdate}
              events={events}
              venues={venues}
              event={event}
            />
          </div>
        </div>
        <div className="col-xl-6">
          <div className="m-portlet">
            <div className="m-portlet__head">
              <div className="m-portlet__head-caption">
                <div className="m-portlet__head-title">
                  <span className="m-portlet__head-icon">
                    <i className="flaticon-information" />
                  </span>
                  <h3 className="m-portlet__head-text">Actions</h3>
                </div>
              </div>
            </div>
            <div className="m-portlet__body">
              <div className="mb-2">
                <button
                    className="btn btn-primary mr-3"
                    onClick={this._generateAllVouchers}
                >
                  Generate all vouchers
                </button>
                <button
                    className="btn btn-primary"
                    onClick={this._generateAndSendAllVouchers}
                >
                  Generate and send all vouchers
                </button>
              </div>
              <small className="font-italic">
                Only vouchers for company registrations will be generated. Vouchers that already have been generated will not be generated again.
              </small>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  loadEvent: id => dispatch(EVENT_ACTIONS.loadRequest(id)),
  loadVenues: () => dispatch(VENUES_ACTIONS.loadAllRequest()),
  updateEvent: (id, values) => dispatch(EVENT_ACTIONS.updateRequest(id, values))
});

const mapStateToProps = function(state) {
  return {
    events: selectEvents(state),
    venues: selectVenues(state)
  };
};

const EventDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(_EventDetails);

export default EventDetails;
